export default __webpack_public_path__ + "static/1-b83e6cb1ab26823a4e60b094834273cf.png";